export default "__VITE_ASSET__DRc_7Huz__"